/* eslint-disable no-underscore-dangle */
/* eslint-disable no-prototype-builtins */
/* eslint-disable no-return-assign */
// import '@babel/polyfill'
// import 'mutationobserver-shim'
import Vue from 'vue'
import './plugins/bootstrap-vue'
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import JsonViewer from 'vue-json-viewer'
// import pluginLogger from './plugins/logger'
import i18n from './i18n'
import App from './App.vue'
import router from './router'
import store from './store'

import './custom_vars.scss'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

// Vue.use(pluginLogger)

Vue.use(JsonViewer)
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)

Vue.config.productionTip = false

if (!window.localStorage) {
  console.log('poly localStorage')
  Object.defineProperty(window, 'localStorage', {
    value: {
      _data: {},
      setItem(id, val) { return this._data[id] = String(val) },
      getItem(id) { return this._data.hasOwnProperty(id) ? this._data[id] : undefined },
      removeItem(id) { return delete this._data[id] },
      clear() { return this._data = {} },
    },
  })
}

let confirmAction = null

const polyConfirm = Vue.observable({
  enable: false,
  title: '',
  ok: () => {
    if (confirmAction) confirmAction()
  },
  show: (title, action) => {
    Vue.prototype.$confirm.title = title
    Vue.prototype.$confirm.enable = true

    confirmAction = action

    return false
  },
})

Object.defineProperty(Vue.prototype, '$confirm', {
  configurable: true,
  get() {
    return polyConfirm
  },
})

new Vue({
  data: store,
  router,
  i18n,
  render: (h) => h(App),
}).$mount('#app')
